import { render } from "./GitHubCTA.vue?vue&type=template&id=52462b64&scoped=true"
import script from "./GitHubCTA.vue?vue&type=script&lang=js"
export * from "./GitHubCTA.vue?vue&type=script&lang=js"

import "./GitHubCTA.vue?vue&type=style&index=0&id=52462b64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52462b64"]])

export default __exports__